export default __webpack_public_path__ + "static/media/(76).41568a1c.jpg";